import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {Link} from "react-router-dom";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import acc from "accounting";
import LSService from "../../../../utilities/localStorageService/LSService";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";

export default class RozliczeniaKierowcowTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

            ileKarta: 0,
            ileGotowka: 0,
            ileCalkowita: 0,

            kolumnyDoExportuDefault: [
                {value: "id", label: 'ID'},
                {value: "dataWpisu", label: 'Data wpisu'},
                {value: "nazTr", label: 'Trasa'},
                {value: "data", label: 'Data'},
                {value: "godz", label: 'Godzina'},
                {value: "idKu", label: 'Kurs'},
                {value: "idKi", label: 'ID Kierowcy'},
                {value: "imie", label: 'Imie kierowcy'},
                {value: "nazwisko", label: 'Nazwisko kierowcy'},
                {value: "pesel", label: 'Pesel kierowcy'},
                {value: "ileJednorazowe", label: 'Ile jednorazowych'},
                {value: "ileMiesieczne", label: 'Ile miesięcznych'},
                {value: "kwotaJednorazowe", label: 'Kwota z jednorazowych'},
                {value: "kwotaMiesieczne", label: 'Kwota z miesiecznych'},
                {value: "kwotaGotowka", label: 'Kwota gotówką'},
                {value: "kwotaKarta", label: 'Kwota kartą'},
                {value: "czyRozliczone", label: 'Czy rozliczono?'},
                {value: "ileOdbicMiesieczne", label: 'Ile odbić biletów miesięcznych?'},
            ],
            wszystkieKolumnyEksport: [
                {value: "id", label: 'ID'},
                {value: "dataWpisu", label: 'Data wpisu'},
                {value: "nazTr", label: 'Trasa'},
                {value: "data", label: 'Data'},
                {value: "godz", label: 'Godzina'},
                {value: "idKu", label: 'Kurs'},
                {value: "idKi", label: 'ID Kierowcy'},
                {value: "imie", label: 'Imie kierowcy'},
                {value: "nazwisko", label: 'Nazwisko kierowcy'},
                {value: "pesel", label: 'Pesel kierowcy'},
                {value: "ileJednorazowe", label: 'Ile jednorazowych'},
                {value: "ileMiesieczne", label: 'Ile miesięcznych'},
                {value: "kwotaJednorazowe", label: 'Kwota z jednorazowych'},
                {value: "kwotaMiesieczne", label: 'Kwota z miesiecznych'},
                {value: "kwotaGotowka", label: 'Kwota gotówką'},
                {value: "kwotaKarta", label: 'Kwota kartą'},
                {value: "czyRozliczone", label: 'Czy rozliczono?'},
                {value: "ileOdbicMiesieczne", label: 'Ile odbić biletów miesięcznych?'},
            ],

        };
        this.renderButtonRozlicz = this.renderButtonRozlicz.bind(this)
        this.renderIloscBiletyJednorazowe = this.renderIloscBiletyJednorazowe.bind(this)
        this.onClickWyszukajBiletyNaKurs = this.onClickWyszukajBiletyNaKurs.bind(this)
        this.renderPodsumowanieWidocznychRekordow = this.renderPodsumowanieWidocznychRekordow.bind(this)
    }

    componentDidMount() {
        this.renderPodsumowanieWidocznychRekordow();
    }

    componentWillReceiveProps(nextprops) {
        this.renderPodsumowanieWidocznychRekordow();
    }

    renderButtonRozlicz(cell, row) {
        if (!Boolean(row.czyRozliczone))
            return (
                <TopButtonAction text={'Rozlicz'}
                                 btnColor={'default'}
                                 btnDisabled={this.props.rozliczanieInProgress}
                                 iconType={'fa fa-check-circle'}
                                 elementStyle={{color: 'forestgreen'}}
                                 onClick={() => {
                                     this.props.handleClickRozlicz(row)
                                 }}
                />
            )
    }

    renderCzyRozliczone(cell, row) {
        if (!Boolean(row.czyRozliczone)) {
            return <span style={{fontWeight: 'bold', color: 'firebrick'}}><i className={'fa fa-times'}></i> nie</span>
        }
        else {
            return <span style={{fontWeight: 'bold', color: 'forestgreen'}}><i className={'fa fa-check'}></i> tak</span>
        }
    }

    renderIloscBiletyJednorazowe(cell, row) {
        if (cell !== 0) {
            return <Link target={'_blank'} to={'/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe'} style={{display: 'block', cursor: 'pointer'}}
                         onClick={() => this.onClickWyszukajBiletyNaKurs(row)}
                         title={'Kliknij aby wyszukać bilety jednorazowe na ten kurs'}>{cell}</Link>
        } else return cell
    }

    onClickWyszukajBiletyNaKurs(obj) {

        if (Boolean(obj)) {
            let params = {
                idKu: obj.idKu,
                data: obj.data,
            }
            LSService.ustawWyszukiwanieBiletowZRozliczeniaKierowcow(params);
        }
    }

    renderSumaCalosc() {
        let suma = 0;
        if (this.props.data.length > 0) {
            for (let i = 0; i < this.props.data.length; i++) {
                suma = suma + parseFloat(this.props.data[i].kwotaJednorazowe) + parseFloat(this.props.data[i].kwotaMiesieczne)
            }
        }
        return acc.formatMoney(suma)
    }

    renderCalaKwota(typ) {
        let suma = 0;

        if (this.props.data.length > 0) {
            for (let i = 0; i < this.props.data.length; i++) {
                if (typ === 'karta') {
                    if (this.props.data[i].kwotaKarta)
                        suma = suma + parseFloat(this.props.data[i].kwotaKarta)

                }
                else {
                    // gotowka
                    if (this.props.data[i].kwotaGotowka)
                        suma = suma + parseFloat(this.props.data[i].kwotaGotowka)
                }
            }
        }
        return acc.formatMoney(suma)
    }

    renderPodsumowanieWidocznychRekordow() {

        document.getElementById("tekstPodsumowania").style.display = "none";
        document.getElementById("ladowaniePodsumowania").style.display = "block";

        console.log(this.refs.tableRozliczenieKierowcow.filter.currentFilter);

        setTimeout(function () {
            if (this.props.data.length > 0) {
                if (Boolean(this.refs.tableRozliczenieKierowcow)) {

                    let arr = Array.from(this.refs.tableRozliczenieKierowcow.props.data, item => {
                        let czyDodac = true;


                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.nazTr)) {
                            if ((item.nazTr.toString().toLowerCase()).indexOf(this.refs.tableRozliczenieKierowcow.filter.currentFilter.nazTr.value.toLowerCase()) < 0) {
                                czyDodac = false
                            }
                        }

                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.idKu)) {
                            if ((item.idKu.toString()).indexOf(this.refs.tableRozliczenieKierowcow.filter.currentFilter.idKu.value) < 0) {
                                czyDodac = false
                            }
                        }

                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.data)) {
                            if ((item.data.toString()).indexOf(this.refs.tableRozliczenieKierowcow.filter.currentFilter.data.value) < 0) {
                                czyDodac = false
                            }
                        }

                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.godz)) {
                            if ((item.godz.toString()).indexOf(this.refs.tableRozliczenieKierowcow.filter.currentFilter.godz.value) < 0) {
                                czyDodac = false
                            }
                        }

                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kierowca)) {
                            if ((item.kierowca.toString().toLowerCase()).indexOf(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kierowca.value.toLowerCase()) < 0) {
                                czyDodac = false
                            }
                        }

                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.ileJednorazowe)) {
                            if ((item.ileJednorazowe.toString()).indexOf(this.refs.tableRozliczenieKierowcow.filter.currentFilter.ileJednorazowe.value) < 0) {
                                czyDodac = false
                            }
                        }

                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.ileMiesieczne)) {
                            if ((item.ileMiesieczne.toString()).indexOf(this.refs.tableRozliczenieKierowcow.filter.currentFilter.ileMiesieczne.value) < 0) {
                                czyDodac = false
                            }
                        }

// suma

                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma)) {

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.comparator === "=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.number) === parseFloat(item.suma)) {
                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.comparator === "<") {
                                if (parseFloat(item.suma) < parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.comparator === ">") {
                                if (parseFloat(item.suma) > parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.comparator === "<=") {
                                if (parseFloat(item.suma) <= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.comparator === ">=") {
                                if (parseFloat(item.suma) >= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.comparator === "!=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.suma.value.number) != parseFloat(item.suma)) {

                                } else czyDodac = false
                            }

                        }




// kwota jednorazowe
                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe)) {

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.comparator === "=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.number) === parseFloat(item.kwotaJednorazowe)) {
                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.comparator === "<") {
                                if (parseFloat(item.kwotaJednorazowe) < parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.comparator === ">") {
                                if (parseFloat(item.kwotaJednorazowe) > parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.comparator === "<=") {
                                if (parseFloat(item.kwotaJednorazowe) <= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.comparator === ">=") {
                                if (parseFloat(item.kwotaJednorazowe) >= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.comparator === "!=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaJednorazowe.value.number) != parseFloat(item.kwotaJednorazowe)) {

                                } else czyDodac = false
                            }

                        }







// kwota miesieczne
                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne)) {

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.comparator === "=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.number) === parseFloat(item.kwotaMiesieczne)) {
                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.comparator === "<") {
                                if (parseFloat(item.kwotaMiesieczne) < parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.comparator === ">") {
                                if (parseFloat(item.kwotaMiesieczne) > parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.comparator === "<=") {
                                if (parseFloat(item.kwotaMiesieczne) <= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.comparator === ">=") {
                                if (parseFloat(item.kwotaMiesieczne) >= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.comparator === "!=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaMiesieczne.value.number) != parseFloat(item.kwotaMiesieczne)) {

                                } else czyDodac = false
                            }

                        }







// kwota gotowka
                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka)) {

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.comparator === "=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.number) === parseFloat(item.kwotaGotowka)) {
                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.comparator === "<") {
                                if (parseFloat(item.kwotaGotowka) < parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.comparator === ">") {
                                if (parseFloat(item.kwotaGotowka) > parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.comparator === "<=") {
                                if (parseFloat(item.kwotaGotowka) <= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.comparator === ">=") {
                                if (parseFloat(item.kwotaGotowka) >= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.comparator === "!=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaGotowka.value.number) != parseFloat(item.kwotaGotowka)) {

                                } else czyDodac = false
                            }

                        }







// kwota karta
                        if (Boolean(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta)) {

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.comparator === "=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.number) === parseFloat(item.kwotaKarta)) {
                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.comparator === "<") {
                                if (parseFloat(item.kwotaKarta) < parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.comparator === ">") {
                                if (parseFloat(item.kwotaKarta) > parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.comparator === "<=") {
                                if (parseFloat(item.kwotaKarta) <= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.comparator === ">=") {
                                if (parseFloat(item.kwotaKarta) >= parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.number)) {

                                } else czyDodac = false
                            }

                            if (this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.comparator === "!=") {
                                if (parseFloat(this.refs.tableRozliczenieKierowcow.filter.currentFilter.kwotaKarta.value.number) != parseFloat(item.kwotaKarta)) {

                                } else czyDodac = false
                            }

                        }


                        if (czyDodac) {
                            return item
                        }
                    })

                    //petla


                    let ileKarta = 0;
                    let ileGotowka = 0;

                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i] !== undefined && arr[i] !== null) {

                            ileKarta = ileKarta + arr[i].kwotaKarta;
                            ileGotowka = ileGotowka + arr[i].kwotaGotowka;
                        }
                    }


                    document.getElementById("tekstPodsumowania").style.display = "block";
                    document.getElementById("ladowaniePodsumowania").style.display = "none";
                    document.getElementById("calkowitaWartoscKarta").innerText = acc.formatMoney(ileKarta);
                    document.getElementById("calkowitaWartoscGotowka").innerText = acc.formatMoney(ileGotowka);
                    document.getElementById("calkowitaWartosc").innerText = acc.formatMoney(ileKarta+ileGotowka)
                }
            }
        }.bind(this),3000)

    }

    render() {

        const options = {
            noDataText: 'Brak pasujących rekordów',
            onSortChange: () => this.renderPodsumowanieWidocznychRekordow(),
            onFilterChange: () => this.renderPodsumowanieWidocznychRekordow(),
        };

        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                                    ref={'tableRozliczenieKierowcow'}
                    >
                        <TableHeaderColumn dataField='id' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazTr' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Trasa</TableHeaderColumn>
                        <TableHeaderColumn dataField='idKu' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return <span className={'label label-ebus-primary'}>{cell}</span>
                                           }}
                        >Kurs</TableHeaderColumn>
                        <TableHeaderColumn dataField='data' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Data</TableHeaderColumn>
                        <TableHeaderColumn dataField='godz' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Godzina</TableHeaderColumn>
                        <TableHeaderColumn dataField='kierowca' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Kierowca</TableHeaderColumn>

                        <TableHeaderColumn dataField='ileOdbicMiesieczne' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >Ile odbić bil. mies.</TableHeaderColumn>
                        <TableHeaderColumn dataField='ileJednorazowe' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.renderIloscBiletyJednorazowe}
                        >Ile jedn.</TableHeaderColumn>

                        <TableHeaderColumn dataField='kwotaJednorazowe' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Suma jedn.</TableHeaderColumn>
                        <TableHeaderColumn dataField='ileMiesieczne' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Ile mies.</TableHeaderColumn>
                        <TableHeaderColumn dataField='kwotaMiesieczne' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Suma mies.</TableHeaderColumn>
                        <TableHeaderColumn dataField='kwotaGotowka' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Kwota gotówka</TableHeaderColumn>
                        <TableHeaderColumn dataField='kwotaKarta' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Kwota karta</TableHeaderColumn>
                        <TableHeaderColumn dataField='suma' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Suma</TableHeaderColumn>
                        <TableHeaderColumn dataField='czyRozliczone' dataSort
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                           dataFormat={this.renderCzyRozliczone}
                            /*filter={{type: 'SelectFilter', options: czyRozliczono, selectText: 'Wybierz'}}
                            formatExtraData={czyRozliczono}*/
                        >Czy rozliczone?</TableHeaderColumn>
                        <TableHeaderColumn dataField='id'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           dataFormat={this.renderButtonRozlicz}
                        >Rozlicz</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                {/*<div>
                    <div className={'pull-right'} style={{marginTop: '5px', marginRight: '5px', fontSize: '18px'}}>
                        <div>Całkowita kwota karty: <span style={{fontWeight: 'bold'}}>{this.renderCalaKwota('karta')}</span></div>
                        <div>Całkowita kwota gotówki: <span style={{fontWeight: 'bold'}}>{this.renderCalaKwota('gotowka')}</span>
                        </div>
                        <div style={{fontSize: '22px'}}>Suma całości: <span style={{fontWeight: 'bold'}}>{this.renderSumaCalosc()}</span></div>
                    </div>
                </div>*/}
                <div>
                    <div id={"ladowaniePodsumowania"}>
                        <div className={"pull-right"} style={{color: "grey", fontStyle: "italic"}}>
                            <i className={"fa fa-cog fa-spin"}></i>Trwa ładowanie podsumowania
                        </div>
                    </div>
                    <div id={"tekstPodsumowania"}>
                        <div className={"pull-right"}>
                            <TopButtonAction text={((this.props.params.idKi === null) || (this.props.params.idKi === undefined) || (this.props.params.idKi === ''))? 'Aby rozliczyć wszytko wybierz kierowce' : 'Rozlicz wszystko'}
                                             btnColor={'default'}
                                             btnDisabled={(this.props.params.idKi === null) || (this.props.params.idKi === undefined) || (this.props.params.idKi === '') || (this.props.rozliczanieInProgress)}
                                             iconType={'fa fa-check-circle'}
                                             elementStyle={{color: 'forestgreen'}}
                                             onClick={() => {
                                                 this.props.handleClickRozliczWszystko(this.props.params)
                                             }}
                            />
                        </div>
                        <div className={"pull-right"}>
                            <p style={{color: "grey", fontStyle: "italic"}}>
                                Podsumowanie:
                            </p>
                            <p>
                                Calkowita kwota karty: <span id={"calkowitaWartoscKarta"}>{acc.formatMoney(this.state.ileKarta)}</span>
                            </p>
                            <p>
                                Calkowita kwota gotówki: <span id={"calkowitaWartoscGotowka"}>{acc.formatMoney(this.state.ileGotowka)}</span>
                            </p>
                            <p>
                                Całkowita wartość: <span id={"calkowitaWartosc"}>{acc.formatMoney(this.state.ileCalkowita)}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczeniaKierowcow/components/RozliczeniaKierowcowTable.js